var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerCarImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10563",
    "data-name": "Group 10563",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 970,
    height: 930,
    viewBox: "0 0 970 930",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3059",
    "data-name": "Rectangle 3059",
    width: 970,
    height: 930,
    fill: "#0090df"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3058",
    "data-name": "Rectangle 3058",
    width: 970,
    height: 930,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3039",
    "data-name": "Rectangle 3039",
    width: 7.79,
    height: 1.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3040",
    "data-name": "Rectangle 3040",
    width: 304.122,
    height: 134.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 388.266,
    height: 101.244,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3042",
    "data-name": "Rectangle 3042",
    width: 56.257,
    height: 86.686,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3043",
    "data-name": "Rectangle 3043",
    width: 303.136,
    height: 49.477,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3049",
    "data-name": "Rectangle 3049",
    width: 297.046,
    height: 213.355,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3050",
    "data-name": "Rectangle 3050",
    width: 389.029,
    height: 114.759,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3051",
    "data-name": "Rectangle 3051",
    width: 231.971,
    height: 87.575,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10562",
    "data-name": "Group 10562",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3037",
    "data-name": "Rectangle 3037",
    width: 970,
    height: 930,
    transform: "translate(0 0)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10561",
    "data-name": "Group 10561",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10560",
    "data-name": "Group 10560",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28892",
    "data-name": "Path 28892",
    d: "M510.758,245.773s-52.4-46.772-61.473-45.9L386.791,218.7s15.7,53.778,38.726,46.829c3.432-1.036,16.942-9.95,25.637-11.817l33.9,2.5s17.87,48.213,38.292,38.489Z",
    transform: "translate(-122.075 -68.775)",
    fill: "#c89866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28893",
    "data-name": "Path 28893",
    d: "M465.652,255.442a14.054,14.054,0,0,0-3.5-6.394c-9.821-10.485-45.786-46.864-51.22-46.568-10.968.6-101.685,26.453-136.281,37.419a54.125,54.125,0,0,0-19.857,11.122c-1.719,1.543-3.492,3.026-5.333,4.431,3.493,7.856,3.19,16.81,7,24.55,2.055,4.173,5.089,8.113,7.694,11.988q1.567,2.334,3.189,4.634a14.485,14.485,0,0,1,7.5-2.22,68,68,0,0,1,10.425.859l10.451-10.412c55.231,20.355,95.648-19.936,95.648-19.936l10.745-17.5,39.428,11.844c13.377,52.917,28.986,51.053,32.393,47.768,2.866-2.765-5.537-39.868-8.278-51.584",
    transform: "translate(-78.732 -69.675)",
    fill: "#d9a46e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28894",
    "data-name": "Path 28894",
    d: "M645.081,471.328q-24.928-32.048-49.849-64.1c-4.439-5.69-13.867-8.82-20.5-4.662q-19.188,11.5-37.923,23.674c-6.461,4.227-7.67,13.616-3.834,19.852l41.029,69.6c4.242,7.208,14.207,8.49,21.2,4.3q22.977-13.77,45.407-28.349c6.825-4.439,9.629-13.689,4.465-20.322m-69.819-50.947a1.921,1.921,0,0,1-.6,2.719L556.44,434.476a2.114,2.114,0,0,1-2.84-.575l-2.686-3.953a1.924,1.924,0,0,1,.6-2.721l18.223-11.374a2.11,2.11,0,0,1,2.837.574Z",
    transform: "translate(-167.526 -137.87)",
    fill: "#4c494b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28895",
    "data-name": "Path 28895",
    d: "M583.847,431.109l-18.185,11.351a2.537,2.537,0,0,1-3.416-.689l-2.681-3.947a2.308,2.308,0,0,1,.721-3.272L578.472,423.2a2.536,2.536,0,0,1,3.414.691l2.682,3.945a2.31,2.31,0,0,1-.721,3.274m-23.1,4.118a1.523,1.523,0,0,0-.476,2.158l2.683,3.946a1.669,1.669,0,0,0,2.249.455l18.186-11.352a1.522,1.522,0,0,0,.475-2.158l-2.681-3.946a1.671,1.671,0,0,0-2.251-.455Z",
    transform: "translate(-176.478 -145.495)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28896",
    "data-name": "Path 28896",
    d: "M608.827,527.6a9.183,9.183,0,0,0,12.342,2.5l18.915-11.808a8.358,8.358,0,0,0,2.6-11.827l-12.245-18.018-33.862,21.139Z",
    transform: "translate(-188.287 -168.079)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28897",
    "data-name": "Path 28897",
    d: "M615.266,531.586h0a9.456,9.456,0,0,1-7.2-4.071l-12.526-18.429,34.723-21.675,12.526,18.429a8.826,8.826,0,0,1-2.755,12.507L621.12,530.156a9.638,9.638,0,0,1-5.854,1.43m-18.3-22.212,11.967,17.6a8.423,8.423,0,0,0,6.416,3.626,8.571,8.571,0,0,0,5.213-1.274l18.919-11.808a7.865,7.865,0,0,0,2.456-11.146l-11.967-17.606Z",
    transform: "translate(-187.959 -167.723)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28898",
    "data-name": "Path 28898",
    d: "M607.958,452.913a9.183,9.183,0,0,0-12.341-2.5L576.7,462.225a8.357,8.357,0,0,0-2.6,11.827l12.246,18.017L620.2,470.931Z",
    transform: "translate(-180.736 -154.518)",
    fill: "#469c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28899",
    "data-name": "Path 28899",
    d: "M585.952,492.491l-12.526-18.427a8.824,8.824,0,0,1,2.756-12.508L595.1,449.747a9.649,9.649,0,0,1,5.856-1.432,9.469,9.469,0,0,1,7.2,4.072l12.526,18.43ZM600.873,449.3a8.591,8.591,0,0,0-5.216,1.272l-18.916,11.81a7.865,7.865,0,0,0-2.456,11.146l11.967,17.607,33-20.6-11.965-17.605a8.436,8.436,0,0,0-6.417-3.626",
    transform: "translate(-180.497 -154.26)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29654",
    "data-name": "Path 29654",
    d: "M0,0,98.124,1.925l.327,16.413L.327,16.413Z",
    transform: "matrix(0.827, -0.562, 0.562, 0.827, 205.561, 352.137)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28900",
    "data-name": "Path 28900",
    d: "M332.578,501l5.914-2.006.632,1.712,1.1-.716-1.715-2.6,5.3-3.216,1.606,2.43,3.945-2.569-2.6-3.934,7.875-4.78,2.44,3.691,6.254-4.072-1.291-3.58,8.812-2.919.467,1.3,2.115-1.377-2.1-2.911,3.833-2.544,2.128,2.944,3.525-2.3-1.758-2.432,3.833-2.544,1.781,2.466,6.145-4-4.745-6.7L303.825,513.9l4.748,6.7,3.618-2.356-.224-4.746,6.268-.272.05,1.05,2.581-1.68-2.358-2.963,4.992-3.645,2.563,3.224,7.7-5.012Z",
    transform: "translate(-95.89 -158.41)",
    fill: "#cdd5de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28901",
    "data-name": "Path 28901",
    d: "M488.914,414.045q-11.7-17.056-23.932-33.761c-3.724-5.081-10.6-7.545-14.96-4.2l-42.187,32.255c-3.885,2.838-5.11,9.428-1.749,14.361q9.771,14.241,19.986,28.194c3.491,4.942,10.405,6.009,14.573,3.731q23.419-12.849,46.835-25.7c4.851-2.658,4.992-9.685,1.435-14.878M471.891,419.2c-1.67.26-3.327-2.506-4.178-3.727-1.963-2.82-3.766-5.759-5.745-8.553s-4.166-5.481-6.179-8.27c-.879-1.22-2.937-3.685-2.076-5.094.963-1.574,4.541-.19,5.884.427a24.643,24.643,0,0,1,9.58,8.243,23.314,23.314,0,0,1,4.469,11.575c.1,1.475.122,5.105-1.755,5.4",
    transform: "translate(-127.547 -128.887)",
    fill: "#423f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28902",
    "data-name": "Path 28902",
    d: "M477.486,406.9c-.962-1.358-1.97-3.07-1.226-4.286,1.161-1.9,5.155-.261,6.352.288a25.1,25.1,0,0,1,9.724,8.363,23.806,23.806,0,0,1,4.53,11.744c.116,1.619.148,5.422-2.057,5.765-1.448.226-2.749-1.314-3.719-2.685-.193-.27-.368-.533-.529-.769-.1-.154-.2-.3-.288-.423-.921-1.322-1.818-2.69-2.688-4.013-.986-1.5-2.006-3.052-3.056-4.535s-2.181-2.964-3.277-4.4c-.961-1.261-1.956-2.565-2.9-3.871-.093-.128-.2-.27-.311-.422-.17-.23-.363-.488-.554-.759m14.251,4.754a24.387,24.387,0,0,0-9.438-8.127c-2.076-.95-4.74-1.669-5.415-.563-.609,1,.751,2.915,1.2,3.545.19.268.376.52.547.747.113.155.221.3.315.43.938,1.3,1.929,2.6,2.891,3.855,1.1,1.438,2.23,2.925,3.289,4.417s2.081,3.05,3.07,4.557c.866,1.318,1.764,2.683,2.677,4,.09.129.189.274.3.431.156.232.336.489.524.762.455.643,1.824,2.568,3,2.386,1.324-.208,1.61-2.841,1.453-5.033a23.118,23.118,0,0,0-4.406-11.4",
    transform: "translate(-150.231 -138.235)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28903",
    "data-name": "Path 28903",
    d: "M527.892,352.831c-18.982-1.4-35.552,12.211-37.012,30.4S503.622,417.3,522.6,418.7s35.551-12.213,37.012-30.4-12.743-34.072-31.722-35.471m-5.134,63.932C504.9,415.445,491.531,400.5,492.9,383.381s16.969-29.926,34.831-28.609,31.229,16.261,29.854,33.381-16.969,29.926-34.831,28.61",
    transform: "translate(-154.894 -121.378)",
    fill: "#b3d1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28904",
    "data-name": "Path 28904",
    d: "M462.672,439.86a12.8,12.8,0,0,1-13.918,11.431,12.6,12.6,0,0,1-11.928-13.337,12.8,12.8,0,0,1,13.918-11.433,12.6,12.6,0,0,1,11.929,13.339",
    transform: "translate(-137.854 -146.757)",
    fill: "#333232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28905",
    "data-name": "Path 28905",
    d: "M522.532,440.939a21.247,21.247,0,0,1-6.906-3.361c-1.109-.35-2.2-.743-3.273-1.2a21.128,21.128,0,0,1-3.347-1.69c-.766-.508-1.461-1.1-2.248-1.573a4.953,4.953,0,0,1-.57-.406c-.1.06-.2.117-.3.178-.136.09-.272.182-.407.273.025.216.046.432.06.649a10.953,10.953,0,0,1-.346,3.948c.966.778,2.167,1.207,3.182,1.927a36.535,36.535,0,0,0,3.76,2.328c1.306.705,2.579,1.474,3.829,2.271.039.027.073.049.105.07.28.112.56.224.847.321a19.459,19.459,0,0,0,2.033.544,4.247,4.247,0,0,1,2.626,1.844,8.915,8.915,0,0,0,1.68-5.95c-.243-.054-.484-.112-.724-.174",
    transform: "translate(-159.444 -148.9)",
    fill: "#423f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28906",
    "data-name": "Path 28906",
    d: "M504.9,437.666c.026.021.054.039.08.06a5.825,5.825,0,0,0,.519.39,10.306,10.306,0,0,0,.482-4.384c-.02-.286-.048-.567-.081-.847-.035.022-.073.042-.107.064-.193.127-.385.258-.576.386.016.149.032.295.043.445a10.043,10.043,0,0,1-.359,3.887",
    transform: "translate(-159.352 -148.96)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28907",
    "data-name": "Path 28907",
    d: "M588.513,405.114q-1.935,1.166-3.866,2.344a1.617,1.617,0,0,1,.145.947c-.3,1.905-.838,3.773-1.231,5.662a6.811,6.811,0,0,1-1.055,2.742,13.674,13.674,0,0,1-1.733,1.76,1.772,1.772,0,0,1-.189.153c-.014.04-.025.08-.038.121a11.541,11.541,0,0,1-.56,1.367,2.557,2.557,0,0,1-.186.548l5.394-3.369a1.951,1.951,0,0,1,.222-.118c.209-.424.455-.838.7-1.294.465-.867.673-1.852,1.094-2.744a2.543,2.543,0,0,1,.385-.583c.148-.675.331-1.347.508-2.018a53.139,53.139,0,0,0,.411-5.517",
    transform: "translate(-182.991 -139.403)",
    fill: "#4c494b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28908",
    "data-name": "Path 28908",
    d: "M584.776,423.25l-5,3.122a2.432,2.432,0,0,1-.3.745c-.118.194-.215.4-.318.6l5.747-3.588a7.8,7.8,0,0,1,.539-1.171,2.51,2.51,0,0,0-.673.291",
    transform: "translate(-182.789 -145.544)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28909",
    "data-name": "Path 28909",
    d: "M605.115,471.243l-.391.245a5.08,5.08,0,0,0-6.7-1.635,4.622,4.622,0,0,0-1.142,6.539l-.391.243a.794.794,0,0,0-.183,1.128l4.475,6.577a.868.868,0,0,0,1.15.292l8.629-5.39a.791.791,0,0,0,.183-1.128l-4.475-6.577a.869.869,0,0,0-1.149-.293m-6.4-.371a3.839,3.839,0,0,1,5.049,1.215l-5.925,3.7a3.492,3.492,0,0,1,.876-4.917m5.965,6.291a2.766,2.766,0,0,0,.421,1.522l.26.382a.8.8,0,0,1-.182,1.129l-.168.1a.87.87,0,0,1-1.151-.294l-.261-.384a2.961,2.961,0,0,0-1.285-.981s-.125-.043-.419-.479a1.473,1.473,0,0,1,.343-2.112,1.62,1.62,0,0,1,2.157.551c.3.434.286.561.286.561",
    transform: "translate(-188.109 -161.451)",
    fill: "#eeeff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28910",
    "data-name": "Path 28910",
    d: "M633.024,506.922a4.633,4.633,0,0,0-1.168,6.5l-5.694,3.558s0,0,0-.005l-.96.6v0l-.39.245a.79.79,0,0,0-.182,1.128l4.474,6.576a.869.869,0,0,0,1.151.295l8.627-5.391a.791.791,0,0,0,.184-1.128l-4.473-6.577a.87.87,0,0,0-1.151-.294l-.39.245,0-.005-.231.146a3.5,3.5,0,0,1,.9-4.875,3.833,3.833,0,0,1,5.017,1.173l.962-.6a5.077,5.077,0,0,0-6.673-1.592M633,518.352a2.772,2.772,0,0,0,.418,1.523l.261.383a.791.791,0,0,1-.184,1.128l-.165.1a.868.868,0,0,1-1.15-.294l-.261-.383a2.973,2.973,0,0,0-1.284-.982s-.127-.043-.422-.479a1.476,1.476,0,0,1,.344-2.113,1.622,1.622,0,0,1,2.158.552c.3.435.286.561.286.561",
    transform: "translate(-197.089 -174.207)",
    fill: "#eeeff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28911",
    "data-name": "Path 28911",
    d: "M301.7,303.843a273.131,273.131,0,0,0,70.166,9.673,176.454,176.454,0,0,1,61.761,11.228c4.846,1.811,9.507,3.558,13.461,5.053,17.429,6.584,28.889,20.108,35.556,7.6s-20.309-27.982-43.191-34.771-37-40.068-37-40.068Z",
    transform: "translate(-95.218 -90.35)",
    fill: "#d9a46e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28912",
    "data-name": "Path 28912",
    d: "M249.1,282.748s17.636,23.977,43.568,31.229l-11.776,12.6-36.3-39.333Z",
    transform: "translate(-77.194 -97.296)",
    fill: "#ee7757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28913",
    "data-name": "Path 28913",
    d: "M304,232.389l25.252,82.432s29.132-5.138,30.5-14.453-19.374-79.158-19.374-79.158Z",
    transform: "translate(-95.945 -76.121)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28914",
    "data-name": "Path 28914",
    d: "M222.625,226.674C198.408,230.3,83.244,259.348,0,272.525V394.046c73.818-15.107,168.067-41.036,250.851-80.345,4.513-1.065-3.785-61.812-28.227-87.026",
    transform: "translate(0 -78.001)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28915",
    "data-name": "Path 28915",
    d: "M537.471,366.987c3.36-2.061,8.367-2.578,10.317-1.019s11.061,6.064,6.206,9.968-13.618-.732-16.924-3.325c-2.549-2.917-2.935-3.474.4-5.624",
    transform: "translate(-168.871 -125.62)",
    fill: "#fce1ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28916",
    "data-name": "Path 28916",
    d: "M1031.686,188.626c0,.009-14.124,3.594-14.122,3.6-11.825,4.126-25.906,4.458-36.017,9.164-5.6,2.611-8.985,8.6-11.355,10.636a42.9,42.9,0,0,0-3.6,2.945c-.218-.123,0,0-.42.262-4.834,5.456-8.639,11.791-8.441,20.864a37.932,37.932,0,0,0,3.072,11.653c15.154,35.784,56.082,19.459,68.429,15.74,5.439-1.634,23.44-13.866,23.029-14.83,9.867-9.329,10.5-10.568,14.411-11.832,4.557-1.474,2.484-33.8.731-36.824-4.815-7.566-14.307-14.045-18.688-13.405-4.727.688-12.606,1.049-17.034,2.025",
    transform: "translate(-302.268 -64.196)",
    fill: "#ebbe8e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28917",
    "data-name": "Path 28917",
    d: "M1099.995,172.374l21.638,78.014s-23.466,13.774-29.707,6.514-32.932-84-32.932-84Z",
    transform: "translate(-334.229 -59.315)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28918",
    "data-name": "Path 28918",
    d: "M1090.792,142.138c-7.611,49.869,17.343,83.051,26.392,88.912,78.138-7.248,144.575-14.293,196.632-20.324V92.486c-73.512,17.8-202.664,48.25-223.024,49.652",
    transform: "translate(-343.815 -31.825)",
    fill: "#515150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28919",
    "data-name": "Path 28919",
    d: "M1224.681,292.906c-4.482.97-8.567-.152-9.127-2.506s2.628-5.06,7.114-6.034,8.571.149,9.125,2.506-2.628,5.054-7.112,6.034",
    transform: "translate(-383.621 -97.732)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28920",
    "data-name": "Path 28920",
    d: "M1201.16,295.693c-4.484.972-8.573-.146-9.128-2.5s2.625-5.057,7.11-6.034,8.572.148,9.13,2.507-2.622,5.052-7.113,6.03",
    transform: "translate(-376.197 -98.692)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28921",
    "data-name": "Path 28921",
    d: "M1176.867,299.581c-4.48.973-8.569-.148-9.127-2.506s2.629-5.057,7.108-6.03,8.575.152,9.135,2.5-2.631,5.056-7.115,6.031",
    transform: "translate(-368.53 -100.03)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28922",
    "data-name": "Path 28922",
    d: "M945.441,209.73s-26.172,10.711-26.17,10.712c-11.874,4-11.529,10.424-20.373,21.656-5.5,3.578-19.719,20.19-18.743,22.115,8.168,16.087,48.583-13.085,60.877-16.95,5.417-1.7,28.12-9.644,27.9-10.078,11.846-4.433,27.688-12.381,24.4-25.3a11.91,11.91,0,0,0-2.525-5c-3.247-3.144-9.8-5.323-14.657-5.532-.343.05-3.592.785-4.669.9-2.134.121-25.969,7.454-26.042,7.475",
    transform: "translate(-277.77 -69.289)",
    fill: "#ebbe8e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28923",
    "data-name": "Path 28923",
    d: "M919.716,1228.273H78.743c-21.818,0-39.5,9.543-39.5,21.311s17.683,21.315,39.5,21.315H919.716c21.818,0,39.5-9.541,39.5-21.315s-17.685-21.311-39.5-21.311",
    transform: "translate(-12.385 -422.66)",
    fill: "#5a5a59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28924",
    "data-name": "Path 28924",
    d: "M223.71,1022.462v-.112l-2.368.02c-.437-.01-.876-.02-1.314-.02-.769,0-1.535.02-2.3.047l-25.927.205c-36.949,3.212-66.015,36.972-66.015,78.147s29.066,74.936,66.015,78.147v.253H223.71v-.108c36.583-2.166,65.656-36.387,65.656-78.292s-29.073-76.126-65.656-78.288",
    transform: "translate(-39.7 -351.8)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28925",
    "data-name": "Path 28925",
    d: "M231.3,1072.041v-.073l-1.533.013c-.285-.007-.567-.013-.854-.013-.5,0-.994.013-1.489.032l-16.81.132c-23.957,2.083-42.8,23.972-42.8,50.669s18.847,48.585,42.8,50.67v.163H231.3v-.073c23.719-1.4,42.57-23.592,42.57-50.76s-18.851-49.359-42.57-50.761",
    transform: "translate(-52.962 -368.874)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28926",
    "data-name": "Path 28926",
    d: "M899.192,1022.462v-.112l-2.367.02c-.439-.01-.877-.02-1.314-.02-.771,0-1.536.02-2.3.047l-25.927.205c-36.949,3.212-66.018,36.972-66.018,78.147s29.069,74.936,66.018,78.147v.253h31.908v-.108c36.583-2.166,65.655-36.387,65.655-78.292s-29.072-76.126-65.655-78.288",
    transform: "translate(-252.888 -351.8)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28927",
    "data-name": "Path 28927",
    d: "M906.781,1064.455v-.073l-1.534.013c-.284-.008-.567-.013-.853-.013-.5,0-.994.013-1.489.031l-16.811.134c-23.956,2.082-42.8,23.968-42.8,50.667s18.847,48.585,42.8,50.67v.162h20.687v-.07c23.72-1.4,42.57-23.593,42.57-50.762s-18.849-49.357-42.57-50.759",
    transform: "translate(-266.151 -366.263)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28928",
    "data-name": "Path 28928",
    d: "M921.993,849.344c.591-4.264,2.735-9.177,2.306-14.793-4.295-56.452-13.192-58.8-15.646-61.158-3.005-2.877-10.492-3.8-12.231-7.391-20.25-41.752-42.057-76.54-52.94-79.862-148.617-45.345-384.3-34.768-455.472,1.692C273.9,746.284,216.548,774.592,139.154,805.5c-6.135,2.45-43.734,23.464-58.775,78.977-.128.474-.8.622-1.221.94-13.907,10.587-18.2,40.851-18.2,60.016,0,23.146,1.458,45.875,27.755,50.43,33.787,5.851,119.3,7.929,238.251,11.428-.1-.717-.186-1.442-.227-2.174-.043-.766-.07-1.535-.1-2.3-3.26-15.142-3.1-31-.846-46.3,3.428-23.255,15.914-47.826,38.417-59.151a26.892,26.892,0,0,1,14.434-2.852,46.885,46.885,0,0,1,9.792-2.645,74.364,74.364,0,0,1,25.374.1c6.628,1.121,12.958,3.652,19,6.408,11.271,5.138,21.569,13.073,30.111,21.738a136.3,136.3,0,0,1,23.161,30.85c9.358,17.493,15.694,37.832,12.227,57.159,2.937,0,5.724-.005,8.327-.005,99.1,0,202.537,1.827,285.1-1.322a154.8,154.8,0,0,1,.939-40.474c2.782-18.585,10.926-38.749,26.1-51.294a83.836,83.836,0,0,1,50.615-18.942c8.406-.306,17.4.652,25.253,3.646a65.419,65.419,0,0,1,17.848,9.9c3.78,2.879,6.575,6.482,9.476,10.165,9.844,12.505,12.129,30.112,13.156,45.227.49,7.227.454,14.481.548,21.726,6.313-2.828,7.514-5.976,12.278-7.467a10.852,10.852,0,0,0,4.118-3.309c.966-1.728,9.183.174,10.891-34.3,2.863-57.825-41.057-91.661-40.964-92.332",
    transform: "translate(-19.239 -225.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10538",
    "data-name": "Group 10538",
    transform: "translate(63.531 681.039)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10537",
    "data-name": "Group 10537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10536",
    "data-name": "Group 10536",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28929",
    "data-name": "Path 28929",
    d: "M98.813,1040c.6-.535,1.2-1.089,1.807-1.656-7.933.454-11.8,1.026-1.807,1.656",
    transform: "translate(-92.829 -1038.341)",
    fill: "#797978"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541",
    transform: "translate(45.727 551.074)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10540",
    "data-name": "Group 10540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10539",
    "data-name": "Group 10539",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28930",
    "data-name": "Path 28930",
    d: "M342.42,840.805c-19.933-1.171-31.522,2.49-51.491,2.247-12.7-.157-77.4-5.564-88.678.039-11.994,5.957-35.729,15.342-52.564,22.306q-4.317,1.745-8.716,3.505c-6.134,2.45-43.735,23.464-58.777,78.974-.127.475-.8.624-1.218.943-6.831,5.2-11.339,15.148-14.163,26.195,18.737-2.664,37.1-5.21,55.95-5.9.147,0-19.155.4-30.355,1.041-.608.565-1.212,1.12-1.807,1.655-10-.63-6.126-1.2,1.807-1.655,22.556-20.983,53.918-62.386,81.594-74.425,30.89-13.436,67-14.887,100.291-21.368,13.509-2.63,82.949-32.075,96.642-33.791-6.193-1.362-22.291,1.457-28.516.232",
    transform: "translate(-66.814 -840.192)",
    fill: "#797978"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10544",
    "data-name": "Group 10544",
    transform: "translate(446.232 604.031)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10542",
    "data-name": "Group 10542",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28931",
    "data-name": "Path 28931",
    d: "M1028.177,923.815c-47.862,2.351-180.326-2.807-184.9-2.643-5.956.477-115.219,6.263-155.717.971-10.43-1.764-26.318-3.033-34.294,6.964-4.91,5.879,5.982,16.5,9.442,23.613,27.612,56.746,67.873,73.415,123.4,68.7,6.674-.019,84.353.787,89.292.661,9.878-.254,36.735-4.087,42.974-11.927,17.211-21.63,83.418-42.236,97.531-46.941,13.5-4.115,27-14.7,23.931-29.4-.613-5.882-6.136-10.585-11.659-10",
    transform: "translate(-652.014 -920.932)",
    fill: "#797978"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10547",
    "data-name": "Group 10547",
    transform: "translate(848.801 537.051)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10546",
    "data-name": "Group 10546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10545",
    "data-name": "Group 10545",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28932",
    "data-name": "Path 28932",
    d: "M1280.784,829.545c-3.005-2.879-10.494-3.8-12.233-7.392q-.813-1.678-1.632-3.342-5.248,1.928-10.766,3.412c-4.817.686-11.062.03-15.888.662-1.321,4.251,37,45.005,50.7,77.151a17.986,17.986,0,0,1,3.158,5.46c.59-4.264,2.734-9.177,2.3-14.792-4.3-56.453-13.192-58.807-15.646-61.159",
    transform: "translate(-1240.231 -818.811)",
    fill: "#161615"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10550",
    "data-name": "Group 10550",
    transform: "translate(469.657 733.392)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10549",
    "data-name": "Group 10549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10548",
    "data-name": "Group 10548",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28933",
    "data-name": "Path 28933",
    d: "M686.242,1118.161c7.011,15.482,11.117,32.58,8.179,48.954,2.937,0,5.724,0,8.326,0,99.1,0,202.536,1.827,285.1-1.323a154.819,154.819,0,0,1,.94-40.474q.261-1.761.591-3.539c-18.805,6.665-157.352,21.123-303.134-3.615",
    transform: "translate(-686.242 -1118.161)",
    fill: "#161615"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_28934",
    "data-name": "Path 28934",
    d: "M155.947,881.2c-1.134.193-24.3,16.3-36.662,31.214-9.7,11.7-19.716,26.289-17.361,27.173,8.833,3.316,18.923,4.657,29.632-6.2,23.011-23.329,33.729-53.8,24.391-52.189",
    transform: "translate(-32.058 -303.21)",
    fill: "#8c8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28935",
    "data-name": "Path 28935",
    d: "M154.546,882.4c-1.133.2-18.152,8.037-33.749,26.17-9.913,11.525-19.328,27.345-16.976,28.226,8.838,3.316,17.632,2.711,29.249-7.253s30.814-48.75,21.476-47.143",
    transform: "translate(-32.652 -303.626)",
    fill: "#d0e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28936",
    "data-name": "Path 28936",
    d: "M433.109,882.531c-26.411,10.475-45.48,49.153-36.64,63.646,1.58,2.591,37.938-2.035,64.35-12.509s50.611-38.845,46.488-47.4c-7.339-15.242-47.786-14.206-74.2-3.733",
    transform: "translate(-124.439 -301.002)",
    fill: "#8c8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28937",
    "data-name": "Path 28937",
    d: "M437.822,886.3c-23.589,9.356-40.621,43.9-32.724,56.844,1.408,2.312,33.883-1.815,57.472-11.173s45.2-34.694,41.521-42.34c-6.557-13.612-42.681-12.687-66.269-3.331",
    transform: "translate(-127.235 -302.585)",
    fill: "#d0e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28938",
    "data-name": "Path 28938",
    d: "M211.418,978.135c-36.621-.169-53.322,4.037-60.406,10-1.012.853-3.933,6.909-3.937,7.79-.036,7.046,34.764,8.472,76.616,8.666,37.089.171,64.91,2.672,71.483-3.225.846-.756,2.91-8.026,2.915-8.827.038-7.046-44.819-14.207-86.672-14.4",
    transform: "translate(-46.418 -336.583)",
    fill: "#323738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28939",
    "data-name": "Path 28939",
    d: "M263.115,1084.236c-17.184-5.192-54.389-5.6-80.193-5.6-30.158,0-63.383-3.863-80.879,2.952-13.093,5.1-13.3,19.42-13.3,26.462,0,5.168,2.484,11.663,10.074,15.291,16.575,7.921,50.505,10,86.671,10,26.893,0,59.846,1.02,76.088-3.528,15.605-4.368,15.034-14.14,15.034-22.2,0-8.4,4.425-17.954-13.5-23.371",
    transform: "translate(-28.009 -370.794)",
    fill: "#323738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29660",
    "data-name": "Path 29660",
    d: "M0,0,3.725,0l.087,126.2-3.725,0Z",
    transform: "translate(89.795 720.966) rotate(-89.047)",
    fill: "#616160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29661",
    "data-name": "Path 29661",
    d: "M0,0,3.725,0l.087,126.2-3.725,0Z",
    transform: "translate(89.626 730.766) rotate(-89.047)",
    fill: "#616160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29662",
    "data-name": "Path 29662",
    d: "M0,0,3.724,0l.088,126.2-3.724,0Z",
    transform: "matrix(0.017, -1, 1, 0.017, 89.462, 740.172)",
    fill: "#616160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29663",
    "data-name": "Path 29663",
    d: "M0,0,3.725,0l.087,126.2-3.725,0Z",
    transform: "matrix(0.017, -1, 1, 0.017, 89.311, 748.797)",
    fill: "#616160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28940",
    "data-name": "Path 28940",
    d: "M107.066,1102.283c-4.011,0-7.261,5.59-7.261,12.482s3.251,12.48,7.261,12.48,7.26-5.588,7.26-12.48-3.25-12.482-7.26-12.482",
    transform: "translate(-31.499 -379.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28941",
    "data-name": "Path 28941",
    d: "M333.3,1106.656c-4.013,0-7.263,5.589-7.263,12.482s3.249,12.48,7.263,12.48,7.261-5.586,7.261-12.48-3.252-12.482-7.261-12.482",
    transform: "translate(-102.901 -380.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28942",
    "data-name": "Path 28942",
    d: "M1199.145,711.285c-14.8-11.164-45.96,4.8-40.079,14.8,16.8,28.563,54.09,58.878,56.512,59.05,18.794,1.342,31.823,6,26.226-4.854-11.143-21.6-35.755-63.791-42.659-69",
    transform: "translate(-365.582 -243.449)",
    fill: "#292928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28943",
    "data-name": "Path 28943",
    d: "M1202.691,713.522c-13.319-11.057-41.929,4.6-36.434,14.065,15.709,27.065,50.352,55.556,52.617,55.72,17.574,1.27,28.84,6.263,23.607-4.014-10.417-20.466-32.349-59.592-39.79-65.771",
    transform: "translate(-367.864 -244.221)",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28944",
    "data-name": "Path 28944",
    d: "M1202.691,713.522c-13.319-11.057-41.929,4.6-36.434,14.065a145.122,145.122,0,0,0,15.218,20.908,118.92,118.92,0,0,1,34.911-15.9c-5.734-9.306-10.807-16.672-13.7-19.071",
    transform: "translate(-367.864 -244.221)",
    fill: "#70706f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28945",
    "data-name": "Path 28945",
    d: "M1293.186,881.543l-.116,9.36h17.984l-1.262-9.371Z",
    transform: "translate(-408.106 -303.343)",
    fill: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28946",
    "data-name": "Path 28946",
    d: "M1282.687,831.356h-22.214c-4.7,0,5.832,16.445,10.534,16.445l24.6.191c0-4.507-7.619-16.9-12.915-16.637",
    transform: "translate(-397.445 -286.076)",
    fill: "#5d5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28947",
    "data-name": "Path 28947",
    d: "M264.657,782.827c-2.054,1.309,24.477,2.163,25.1,2.163,20.707.005,46.022-1.5,111.369-4.32,29.582-1.276,92.579,2.279,95.11,1.764,24.18-4.915,114.735-104.7,172.719-108.316,0-.386.389-.66.433-1.042-100.863-8.847-174.754-36.668-404.731,109.75",
    transform: "translate(-83.493 -228.854)",
    fill: "#292928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28948",
    "data-name": "Path 28948",
    d: "M274.65,782.742c-2.052,1.31,20.7.6,21.326.61,22.244.336,43.106-2.793,108.453-5.61,29.583-1.274,86.907.88,89.436.367,25.018-5.085,113.924-100.187,169.557-103.373,1.693-.1-14.136-1.373-16.26-1.373-70.941,0-139.748-38.811-372.512,109.379",
    transform: "translate(-86.641 -230.132)",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28949",
    "data-name": "Path 28949",
    d: "M1068.628,887.52l-30.149.8a8.5,8.5,0,0,0-8.452,8.562l.086,3.029a8.543,8.543,0,0,0,8.934,8.1l30.148-.8a8.5,8.5,0,0,0,8.454-8.564l-.088-3.026a8.542,8.542,0,0,0-8.933-8.1",
    transform: "translate(-325.085 -305.403)",
    fill: "#8c8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28950",
    "data-name": "Path 28950",
    d: "M1073.082,898.044l-44.5,1.18a3.087,3.087,0,0,0,.178,6.171l44.5-1.177a3.089,3.089,0,0,0-.177-6.175",
    transform: "translate(-323.695 -309.025)",
    fill: "#757474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28951",
    "data-name": "Path 28951",
    d: "M538.223,992.7c-89.188-1.093-98.9,80.123-90.407,130.387l176.358.708c-1.378-30.057,1.39-130.026-85.951-131.094",
    transform: "translate(-140.559 -341.594)",
    fill: "#272726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28952",
    "data-name": "Path 28952",
    d: "M1200.325,1008.106c-79.652-1.266-93.073,76.635-74.9,119.807l150.332-22.981,5.882-4.535c-1.292-30.057-3.313-91.053-81.318-92.291",
    transform: "translate(-352.934 -346.893)",
    fill: "#272726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28953",
    "data-name": "Path 28953",
    d: "M547.543,1030.543v-5.36l-31.909.253c-36.947,3.215-66.015,36.972-66.015,78.146s29.067,74.936,66.015,78.148v.255h31.909v-5.36c26.728-11.412,45.66-39.812,45.66-73.043s-18.932-61.63-45.66-73.039",
    transform: "translate(-141.904 -352.775)",
    fill: "#363535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28954",
    "data-name": "Path 28954",
    d: "M555.347,1025.183c-38.294,0-69.336,35.1-69.336,78.4s31.043,78.4,69.336,78.4,69.338-35.1,69.338-78.4-31.043-78.4-69.338-78.4",
    transform: "translate(-153.39 -352.775)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28955",
    "data-name": "Path 28955",
    d: "M596.413,1082.325l-27.751,17.362,6.6-31.616c-5.281-1.882-11.4-4.2-17.262-4.2-5.983,0-9.359.937-14.734,2.894l4.5,32.925-26.114-19.528c-6.244,6.147-8.731,11.424-11.765,20.142l26.017,18.137-27.885,15.13c1.738,14.135,3.759,15.945,13.1,24.991l27.986-24.2-7.272,41.406a82,82,0,0,0,16.027,2.206,112.533,112.533,0,0,0,15.406-1.9l-6.643-41.273,28.44,23.114c9.629-8.679,8.506-13.335,10.722-27.29l-30.289-13.684,31.626-13.372c-2.822-9.505-4.14-14.561-10.7-21.234",
    transform: "translate(-160.334 -366.087)",
    fill: "#a2a3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28956",
    "data-name": "Path 28956",
    d: "M556.358,1060.329c-29.57,0-53.54,26.177-53.54,58.467s23.97,58.468,53.54,58.468S609.9,1151.087,609.9,1118.8s-23.971-58.467-53.538-58.467m0,111.7c-26.923,0-48.748-23.834-48.748-53.234s21.825-53.232,48.748-53.232S605.1,1089.4,605.1,1118.794s-21.825,53.234-48.746,53.234",
    transform: "translate(-158.694 -364.869)",
    fill: "#a2a3a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3048",
    "data-name": "Rectangle 3048",
    width: 32.471,
    height: 149.638,
    transform: "translate(830.549 679.409)",
    fill: "#363535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28957",
    "data-name": "Path 28957",
    d: "M1185.68,1035.857c-36.164,0-65.481,33.534-65.481,74.9s29.317,74.9,65.481,74.9,65.481-33.535,65.481-74.9-29.317-74.9-65.481-74.9",
    transform: "translate(-353.546 -356.448)",
    fill: "#363535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28958",
    "data-name": "Path 28958",
    d: "M1224.595,1035.857c-36.162,0-65.48,33.534-65.48,74.9s29.317,74.9,65.48,74.9,65.481-33.535,65.481-74.9-29.316-74.9-65.481-74.9",
    transform: "translate(-365.828 -356.448)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28959",
    "data-name": "Path 28959",
    d: "M1270.443,1085.9l-25.31,16.588,6.017-30.2c-4.817-1.8-10.4-4.017-15.744-4.017-5.457,0-8.537.9-13.439,2.768l4.1,31.454-23.818-18.657c-5.7,5.876-7.964,10.915-10.734,19.244l23.732,17.327-25.433,14.456c1.583,13.5,3.429,15.231,11.945,23.873l25.523-23.122-6.632,39.559a71.892,71.892,0,0,0,14.619,2.107,98.129,98.129,0,0,0,14.053-1.818l-6.06-39.43,25.941,22.081c8.781-8.291,7.758-12.742,9.779-26.073l-27.625-13.073,28.846-12.772c-2.578-9.084-3.776-13.913-9.761-20.289",
    transform: "translate(-375.518 -367.601)",
    fill: "#a2a3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28960",
    "data-name": "Path 28960",
    d: "M1233.91,1064.889c-26.97,0-48.833,25.01-48.833,55.858s21.863,55.858,48.833,55.858,48.831-25.008,48.831-55.858-21.863-55.858-48.831-55.858m0,106.715c-24.556,0-44.463-22.771-44.463-50.858s19.907-50.858,44.463-50.858,44.461,22.769,44.461,50.858-19.907,50.858-44.461,50.858",
    transform: "translate(-374.022 -366.438)",
    fill: "#a2a3a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10553",
    "data-name": "Group 10553",
    transform: "translate(481.777 547.608)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10552",
    "data-name": "Group 10552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10551",
    "data-name": "Group 10551",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28961",
    "data-name": "Path 28961",
    d: "M996.434,835.5c.414,5.289,1.262,7.393-.253,12.354-.506,1.655-1.092,3.289-1.743,4.908-5.707,19.693-14.3,37.922-22.876,55.934q-1,3.046-1.981,6.155c-7.918,24.839-16.52,51.825-23.779,74.589q-.591,1.858-1.174,3.678c-2.047,5.434-4.088,11.2-6.47,16.839-.792,1.88-1.625,3.747-2.507,5.582-7.668,17.455-29.143,28.04-48.353,27.815l-6.583.072c-44.948.481-161.358,3.094-163.2.741-4.3-5.292-3.854-24.9-3.937-27.354-1.848-56.362-5.809-177.14-5.809-177.14-.066-2.02-.975-3.632-2.031-3.6s-1.853,1.694-1.787,3.713c0,0,3.792,115.585,5.687,173.374.043,1.286-.478,25.629,4.584,33.45,1.807,2.795,124.09,1.331,166.846.739,2.139-.029,4.236-.061,6.288-.115,21.6-.129,43.691-10.125,52.522-30.267q1.348-2.776,2.556-5.611c2.419-5.662,4.443-11.438,6.23-17.042q.6-1.9,1.215-3.847c7.214-22.843,15.745-49.842,23.592-74.667q.978-3.1,1.962-6.151c9-16.612,14.521-34.252,21.712-52.128a32.419,32.419,0,0,0,2.4-5.123c1.483-5.334,2.22-10.734.292-16.768-.4-1.64-2.28.06-3.4-.13",
    transform: "translate(-703.95 -834.907)",
    fill: "#464545"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_28962",
    "data-name": "Path 28962",
    d: "M1007.182,782.662l-23.334-72.5c.089-4.745-13.644-20.861-18.6-20.944l-140.862-4.843c-4.952-.084-66.058,18.253-110.267,78.189l-9.43,13.336c-4.479,4.624-3.874,11.89,1.079,11.975l298.865.63c4.955.085,2.46-1.1,2.549-5.845",
    transform: "translate(-221.452 -235.5)",
    fill: "#292928"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10556",
    "data-name": "Group 10556",
    transform: "translate(187.877 438.645)",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10555",
    "data-name": "Group 10555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10554",
    "data-name": "Group 10554",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28963",
    "data-name": "Path 28963",
    d: "M274.65,782.742c-1.65,1.051,12.706.8,18.742.667,1.07-.663,2.149-1.315,3.243-1.941,15.007-8.569,32.127-14.589,48.032-20.882q10.391-4.112,21.16-7.245c7.015-2.059,14.079-3.909,21.276-5.282q3.676-.7,7.364-1.338c3.323-1.028,6.682-1.982,10.079-2.836a296.653,296.653,0,0,1,30.661-5.94c23.637-3.345,47.325-6.523,71.2-7.761,13.638-.707,27.3-.966,40.954-.952q7.542.011,15.081.126c33.468-25.992,71.8-52.951,100.981-54.621,1.693-.1-14.136-1.373-16.26-1.373-70.941,0-139.748-38.811-372.512,109.379",
    transform: "translate(-274.518 -668.777)",
    fill: "#70706f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_28964",
    "data-name": "Path 28964",
    d: "M985.191,718.283c.073-4.013-11.535-17.636-15.724-17.708l-119.082-4.091c-4.186-.072-55.845,15.429-93.217,66.1L749.2,773.855c-3.786,3.91-3.272,10.051.913,10.122l252.655.536c4.186.07,2.077-.929,2.152-4.943Z",
    transform: "translate(-235.646 -239.666)",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10559",
    "data-name": "Group 10559",
    transform: "translate(537.763 457.499)",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10558",
    "data-name": "Group 10558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10557",
    "data-name": "Group 10557",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28965",
    "data-name": "Path 28965",
    d: "M1085.3,764.975l-44.818,43.211,55.021.119c4.186.07,2.077-.929,2.153-4.943Z",
    transform: "translate(-866.149 -720.734)",
    fill: "#70706f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28966",
    "data-name": "Path 28966",
    d: "M785.755,784.61l55.2.115,88.535-85.365-53.421-1.837Z",
    transform: "translate(-785.755 -697.523)",
    fill: "#70706f"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3052",
    "data-name": "Rectangle 3052",
    width: 40.499,
    height: 9.114,
    transform: "translate(500.898 535.706)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28967",
    "data-name": "Path 28967",
    d: "M780.883,778.823c-17.349,0-28.787,8.251-31.415,17.695-6.062,21.787,14.066,18.972,31.415,18.972s36.192,2.815,31.415-18.972c-2.1-9.563-14.065-17.695-31.415-17.695",
    transform: "translate(-236.191 -268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28968",
    "data-name": "Path 28968",
    d: "M805.672,810.755c-4.224,0-3.069,10.185,1.155,10.185l21.434.116c1.979-1.975,2.488-7.656,1.832-10.3Z",
    transform: "translate(-253.442 -278.988)",
    fill: "#d0e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28969",
    "data-name": "Path 28969",
    d: "M900.915,288.662,779.082,332.219a4.693,4.693,0,0,1-5.941-2.6l-25-64.22a4.388,4.388,0,0,1,2.713-5.694l121.833-43.556a4.693,4.693,0,0,1,5.941,2.6l25,64.22a4.388,4.388,0,0,1-2.713,5.694",
    transform: "translate(-236.03 -74.283)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29655",
    "data-name": "Path 29655",
    d: "M0,0,47.184.647l.3,20.848L.3,20.847Z",
    transform: "matrix(0.937, -0.35, 0.35, 0.937, 582.974, 170.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29656",
    "data-name": "Path 29656",
    d: "M0,0,112.85,1.547l.029,2.026L.029,2.026Z",
    transform: "translate(538.83 238.094) rotate(-20.458)",
    fill: "#539572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29657",
    "data-name": "Path 29657",
    d: "M0,0,112.85,1.547l.029,2.026L.029,2.026Z",
    transform: "translate(541.023 243.727) rotate(-20.458)",
    fill: "#539572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28970",
    "data-name": "Path 28970",
    d: "M789.162,340.7l.925,2.376a5.715,5.715,0,0,1-1.383.759,5.218,5.218,0,0,1-4.231-.173,6.016,6.016,0,0,1-2.915-3.392,5.351,5.351,0,0,1-.026-4.2,4.894,4.894,0,0,1,3.006-2.735,6.094,6.094,0,0,1,1.618-.356l.927,2.382a5.349,5.349,0,0,0-1.489.285,2.144,2.144,0,0,0-1.365,1.41,3.3,3.3,0,0,0,.134,2.3,3.5,3.5,0,0,0,1.5,1.892,2.449,2.449,0,0,0,2.1.141,4.694,4.694,0,0,0,1.2-.685",
    transform: "translate(-246.527 -114.58)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28971",
    "data-name": "Path 28971",
    d: "M794.731,335.265l.449,1.154.034-.012q.367-1.668,1.352-2.02a2.63,2.63,0,0,1,.42-.1l.832,2.136a6.149,6.149,0,0,0-.866.233q-1.371.491-.766,2.042l1.333,3.424-2.485.888-2.683-6.894Z",
    transform: "translate(-250.073 -115.032)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28972",
    "data-name": "Path 28972",
    d: "M806.973,336.505l2.1-.75a2.9,2.9,0,0,1-2.094,3.395,3.257,3.257,0,0,1-2.762-.148,4.457,4.457,0,0,1-1.944-2.437,4.008,4.008,0,0,1-.145-2.931,3.029,3.029,0,0,1,1.938-1.815,3.5,3.5,0,0,1,1.865-.125,3.188,3.188,0,0,1,1.665.843,7.264,7.264,0,0,1,1.377,2.333l-4.156,1.486q.65,1.518,1.575,1.187a.9.9,0,0,0,.487-.4.851.851,0,0,0,.1-.632m-2.584-1.347,1.808-.647a2.584,2.584,0,0,0-.65-.992.765.765,0,0,0-.786-.115.8.8,0,0,0-.58.592,2.234,2.234,0,0,0,.209,1.163",
    transform: "translate(-253.091 -114.114)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28973",
    "data-name": "Path 28973",
    d: "M814.8,321.52l2.476-.885,4.11,10.559-2.493.891-.353-.908-.035.013a2.4,2.4,0,0,1-1.433,1.81,2.24,2.24,0,0,1-2.16-.371,5.238,5.238,0,0,1-1.717-2.443,4.913,4.913,0,0,1-.353-2.913,2.156,2.156,0,0,1,1.419-1.643,2.677,2.677,0,0,1,2.276.356Zm2.748,7.059q-.662-1.7-1.6-1.364-.968.347-.266,2.152a2.684,2.684,0,0,0,.744,1.147.885.885,0,0,0,.895.18.771.771,0,0,0,.5-.706,3.023,3.023,0,0,0-.264-1.409",
    transform: "translate(-256.51 -110.333)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28974",
    "data-name": "Path 28974",
    d: "M823.011,321.13a1.1,1.1,0,0,1,.068-.954,1.4,1.4,0,0,1,.794-.668,1.486,1.486,0,0,1,1.065,0,1.163,1.163,0,0,1,.7.679,1.1,1.1,0,0,1-.068.952,1.4,1.4,0,0,1-.8.674,1.468,1.468,0,0,1-1.054-.011,1.161,1.161,0,0,1-.706-.674m.873,2.044,2.494-.891,2.683,6.894-2.494.891Z",
    transform: "translate(-259.725 -109.912)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28975",
    "data-name": "Path 28975",
    d: "M830.136,319.285l2.494-.891.714,1.835.968-.346.706,1.814-.986.352,1.978,5.081-2.476.885-1.983-5.1-.942.337-.7-1.8.942-.337Z",
    transform: "translate(-261.927 -109.562)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28976",
    "data-name": "Path 28976",
    d: "M852.525,317.065l.925,2.376a5.708,5.708,0,0,1-1.383.759,5.218,5.218,0,0,1-4.231-.173,6.015,6.015,0,0,1-2.915-3.392,5.351,5.351,0,0,1-.026-4.2A4.894,4.894,0,0,1,847.9,309.7a6.093,6.093,0,0,1,1.618-.356l.927,2.382a5.349,5.349,0,0,0-1.489.285,2.143,2.143,0,0,0-1.365,1.41,3.3,3.3,0,0,0,.134,2.3,3.5,3.5,0,0,0,1.5,1.892,2.448,2.448,0,0,0,2.1.141,4.692,4.692,0,0,0,1.2-.685",
    transform: "translate(-266.525 -106.447)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28977",
    "data-name": "Path 28977",
    d: "M862.519,317.73l-.354-.908-.035.013a3.876,3.876,0,0,1-.543,1.175,1.833,1.833,0,0,1-.89.634,2.249,2.249,0,0,1-2.182-.363,5.374,5.374,0,0,1-1.73-2.489,4.852,4.852,0,0,1-.35-2.879,2.125,2.125,0,0,1,1.4-1.619,1.971,1.971,0,0,1,1.1-.1,3.881,3.881,0,0,1,1.179.521l.035-.012-.335-.863,2.493-.891,2.684,6.894Zm-1.356-3.485q-.668-1.715-1.628-1.372t-.3,2.061q.693,1.784,1.7,1.426.927-.333.233-2.115",
    transform: "translate(-270.271 -106.657)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28978",
    "data-name": "Path 28978",
    d: "M870.225,307.1l.449,1.154.034-.012q.366-1.668,1.352-2.019a2.622,2.622,0,0,1,.419-.1l.832,2.136a6.06,6.06,0,0,0-.866.233q-1.37.49-.766,2.041l1.333,3.424-2.485.888-2.683-6.894Z",
    transform: "translate(-273.9 -105.34)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28979",
    "data-name": "Path 28979",
    d: "M879.374,297.43l2.476-.885,4.11,10.559-2.493.891-.352-.907-.035.012a2.4,2.4,0,0,1-1.433,1.81,2.236,2.236,0,0,1-2.16-.371,5.236,5.236,0,0,1-1.717-2.442,4.913,4.913,0,0,1-.352-2.913,2.155,2.155,0,0,1,1.419-1.643,2.677,2.677,0,0,1,2.276.356Zm2.748,7.059q-.662-1.7-1.6-1.364-.968.346-.266,2.152a2.685,2.685,0,0,0,.744,1.146.884.884,0,0,0,.894.18.771.771,0,0,0,.5-.706,3.023,3.023,0,0,0-.264-1.408",
    transform: "translate(-276.892 -102.044)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29658",
    "data-name": "Path 29658",
    d: "M0,0,18.12.3l.3,18.632L.3,18.632Z",
    transform: "matrix(0.415, -0.91, 0.91, 0.415, 527.761, 201.332)",
    fill: "#ffe800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29659",
    "data-name": "Path 29659",
    d: "M0,0,18.12.3l.3,18.632L.3,18.632Z",
    transform: "matrix(0.415, -0.91, 0.91, 0.415, 541.03, 196.588)",
    fill: "#00862f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28980",
    "data-name": "Path 28980",
    d: "M939.273,274.36c-.813.345-7.178,3.069-8.024,3.433-.052.019-.1.04-.155.056a.014.014,0,0,0,0,.011c-7.937,3.441-17.167,7.732-24.024,11.173a59.979,59.979,0,0,0-8.1,4.8c-.875.571-1.718,1.162-2.516,1.76-.135-.019,0,0-.289.172-3.472,3-5.8,5.762-6.22,9.568a10.869,10.869,0,0,0,.99,5.311c7.683,12.96,35.049-.172,43.3-3.514,3.634-1.472,76.421-26.545,76.214-26.894,7.866-3.8,5.217-23.787,1.37-34.241-.621-1.674-8.048-4.592-9-5.622-2.671-2.507-25.5,5.713-28.968,5.622-.235.045-10.927,7.539-11.676,7.646-1.5.132-17.86,2.747-20.745,3.649-3.114.967-2.126,17.108-2.154,17.069",
    transform: "translate(-280.875 -82.552)",
    fill: "#ebbe8e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28981",
    "data-name": "Path 28981",
    d: "M910.826,328.328c2.282,5.13,4.9,10.612,1.767,12.457s-12.964,6.076-17.761-1.715,1.653-13.151,7.166-15.2,6.39-.678,8.827,4.462",
    transform: "translate(-281.889 -111.13)",
    fill: "#fce1ca",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCarImg);
export default __webpack_public_path__ + "static/media/banner-car-img.952b1b03a953c6b1a31b62e9853dd4f3.svg";
export { ForwardRef as ReactComponent };